
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.33686',
  depVersions: {
  "documents-public-ui": "static-1.33686",
  "client-types": "static-1.441",
  "documents-lib": "static-1.33691",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.1801",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4702",
  "highcharts": "static-8.97",
  "hs-promise-utils": "static-1.5276",
  "hs-test-utils": "static-1.7665",
  "hub-http": "static-1.5872",
  "hubspot-dlb": "static-2.1773",
  "HubStyleTokens": "static-2.11104",
  "I18n": "static-7.1537",
  "jasmine-immutable": "static-1.2699",
  "jasmine-runner": "static-1.6136",
  "lodash": "static-1.3",
  "quartz": "static-1.6558",
  "react": "static-7.175",
  "react-dlb": "static-1.69",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.65",
  "react-rhumb": "static-1-feature-id-1324-better-marker-tracking.14",
  "reporting-data": "static-1.65995",
  "reporting-testing-lib": "static-1.7929",
  "reporting-visualizations": "static-1.58072",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4429",
  "webpack-env": "static-1.54",
  "atom": "static-1.4757",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2146",
  "classnames": "static-2.10",
  "crm_schema": "static-3.90904",
  "cssUtils": "static-1.693",
  "customer-data-filters-ui": "static-1.38471",
  "customer-data-objects": "static-1.7296",
  "customer-data-property-utils": "static-1.7751",
  "data-fetching-client": "static-1.9359",
  "enviro": "static-4.371",
  "FireAlarmUi": "static-1.4220",
  "flux-actions": "static-1.294",
  "FormsCommonComponents": "static-1.84944",
  "FormUrlGenerator": "static-2.4416",
  "foundations-components": "static-1.7269",
  "history": "static-4.47",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.3825",
  "HubStyle": "static-2.11412",
  "icons": "static-2.610",
  "immutable": "static-2.19",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.6825",
  "metrics-js": "static-1.9296",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.334",
  "property-description-translator": "static-1.3544",
  "property-translator": "static-1.5098",
  "quartz-config": "static-1.336",
  "quartz-core": "static-1.5777",
  "quick-fetch": "static-1.3622",
  "raven": "static-3.5564",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5070",
  "react-virtualized": "static-2.92",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.7844",
  "reference-resolvers-lite": "static-1.7776",
  "report-customization-components": "static-1.12190",
  "reporting-enablement": "static-1.21690",
  "reporting-reports": "static-1.65674",
  "reporting-snowflake": "static-1.54614",
  "reporting-ui-components": "static-2.63268",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4289",
  "sales-content-partitioning": "static-1.8619",
  "SalesContentIndexUI": "static-3.8725",
  "sanitize": "static-1.4160",
  "sanitize-text": "static-1.7826",
  "self-service-api": "static-1.9910",
  "SharedI18nStrings": "static-1.179",
  "SharedLegalStrings": "static-1.1453",
  "signup-constants": "static-1.18168",
  "signup-ui-lego-core": "static-1.20178",
  "signup-ui-url-generator": "static-2.7711",
  "styled-components": "static-2.83",
  "StyleGuideUI": "static-3.481",
  "superstore": "static-1.4455",
  "transmute": "static-2.77",
  "ui-addon-form-validation": "static-1.10681",
  "ui-addon-i18n": "static-1.10810",
  "ui-addon-react-router-dom": "static-1.9230",
  "ui-addon-upgrades": "static-9.17394",
  "ui-asset-management-lib": "static-1.10538",
  "ui-images": "static-2.1055",
  "UIComponents": "static-3.8051",
  "usage-tracker": "static-1.7020",
  "usage-tracker-container": "static-1.7010",
  "usage-tracker-core": "static-1.6870",
  "usage-tracker-public": "static-1.6831",
  "viral-links-lib": "static-1.6702",
  "hs-promise-rejection-tracking": "static-1.5234",
  "raven-hubspot": "static-1.5871",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3120",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.2835",
  "quartz-webpack": "static-1.2782",
  "ai-components-ui-library": "static-1.8051",
  "amplitude-session-replay-browser": "static-1.53",
  "foundations-assets": "static-1.4515",
  "foundations-theming": "static-1.4085",
  "react-transition-group": "static-1.7",
  "usage-tracker-session-replay": "static-1.4706",
  "foundations-theming-base": "static-1.3070",
  "HeadJS": "static-2.686",
  "framer-motion": "static-1.64",
  "hs-test-utils-bend-plugin": "static-1.2776",
  "msw": "static-1.39",
  "testing-library": "static-1.145",
  "i18n-data": "static-1.214",
  "moment-timezone": "static-5.76",
  "jasmine": "static-4.4015",
  "csstype": "static-1.50",
  "frontend-preferences-client": "static-1.7608",
  "graphql": "static-1.75",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3352",
  "persist-promise": "static-1.3370",
  "reporting-client-types": "static-1.2350",
  "hs-story-utils": "static-1.9113",
  "react-flip-move": "static-1.63",
  "hub-http-shared-msw-handlers": "static-1.9178",
  "hubspotter-http": "static-1.4371",
  "sassPrefix": "static-1.149",
  "conversations-skeleton-state": "static-1.6936",
  "crm-message-bus": "static-1.42046",
  "customer-data-filters-ui-msw-helpers": "static-1.20905",
  "customer-data-objects-ui-components": "static-1.12686",
  "customer-data-reference-ui-components": "static-1.12817",
  "customer-data-ui-utilities": "static-1.9508",
  "framework-builder-read-service-client": "static-1.3740",
  "framework-data-schema-quick-fetch": "static-1.6453",
  "framework-data-schema-resolvers": "static-1.6548",
  "inbound-db-properties-service-client": "static-1.3571",
  "multi-account-reference-resolvers": "static-1.649",
  "onboarding-tours": "static-1.16107",
  "reporting-datasets-permissions-lib": "static-1.12667",
  "ui-addon-teams": "static-1.21067",
  "apollo-stack-hubspot": "static-3.79",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.67246",
  "customer-data-properties": "static-1.50440",
  "forms-ai-lib": "static-1.3804",
  "forms-utils-lib": "static-1.11949",
  "foundations-components-test-utils": "static-1.4752",
  "react-dnd-compat": "static-1.4309",
  "react-tinymce": "static-1.54309",
  "tinymce-config": "static-2.53435",
  "ui-gdpr-components": "static-1.10031",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.3538",
  "floating-ui": "static-1.49",
  "react-aria": "static-1.59",
  "tanstack-table": "static-1.48",
  "trellis-assets": "static-1.951",
  "ui-fonts": "static-1.366",
  "dispatcher": "static-1.129",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.766",
  "mobile-manifest-mixins": "static-1.459",
  "quartz-auth": "static-1.233",
  "quartz-head": "static-1.223",
  "quartz-i18n": "static-1.233",
  "quartz-test": "static-1.233",
  "batch-promise": "static-1.1213",
  "external-options-client-types": "static-1.3876",
  "react-colorpicker": "static-2.9898",
  "reporting-insights-lib": "static-1.836",
  "copilot-toolkit": "static-1.10237",
  "data-quality-ui-library": "static-1.12061",
  "html-to-image": "static-1.47",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40392",
  "reporting-plugins": "static-1.9835",
  "ui-addon-draggable-compat": "static-2.3939",
  "ui-addon-opt": "static-4.8074",
  "ui-shepherd-react": "static-3.9825",
  "zustand": "static-1.51",
  "growth-payments-core": "static-1.24400",
  "hubspot-apollo-client": "static-1.4565",
  "sales-templates-service-types-lib": "static-1.3887",
  "ui-business-units-lib": "static-1.8701",
  "merchandise-lib": "static-1.253",
  "emoji-regex": "static-1.7",
  "feature-store-service-types": "static-1.4213",
  "purchase-motions-components": "static-1.5310",
  "salesImages": "static-1.518",
  "ts-schema": "static-1.3797",
  "upgrade-management-service-types": "static-1.4204",
  "timezone-utils": "static-2.4929",
  "bender-build-tools": "static-1.2798",
  "chatspot-core": "static-1.19867",
  "bend-plugin-foundations-theming": "static-1.2568",
  "stylex": "static-1.25",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3515",
  "crm-pipelines-api-client-types": "static-1.3858",
  "multi-currency-client-types": "static-1.3415",
  "getting-started-shared-tasks": "static-1.17545",
  "growth-data-modal": "static-1.5015",
  "growth-onboarding-confetti": "static-1.2736",
  "growth-onboarding-next-action-utils": "static-1.1177",
  "navigation-components": "static-1.16930",
  "onboarding-tours-client": "static-1.4321",
  "onboarding-tours-utils": "static-1.173",
  "ui-shepherd-tracker": "static-1.7206",
  "ui-universal-auth": "static-1.8539",
  "user-context": "static-1.4774",
  "cms-field-types": "static-1.4488",
  "content-icons-ui": "static-1.2110",
  "integrations-lib": "static-1.15042",
  "calling-global-api": "static-1.63254",
  "calling-internal-common": "static-1.30974",
  "calling-lifecycle-internal": "static-1.64636",
  "calling-lifecycle-messages": "static-1.56930",
  "commerce-products-lib": "static-1.8498",
  "crm-links": "static-1.5933",
  "file-manager-components": "static-1.22548",
  "google-libphonenumber": "static-1.31",
  "hs-entities": "static-1.334",
  "inbounddb-objects-service-types": "static-1.3943",
  "meetings-icalendar-utils-lib": "static-1.318",
  "object-builder-ui-client": "static-1.47606",
  "pipeline-validation-client-types": "static-1.3679",
  "property-value-citations": "static-1.1054",
  "pulse": "static-1.168",
  "smart-property-lib": "static-1.5464",
  "tiered-pricing": "static-1.644",
  "ui-addon-iframeable": "static-1.8697",
  "final-form": "static-1.63",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19263",
  "tinymce-themes": "static-1.55405",
  "data-token-picker": "static-1.15860",
  "hub-http-contrib": "static-1.2733",
  "interframe": "static-3.4474",
  "tinymce-data": "static-1.39520",
  "tinymce-plugins": "static-1.56549",
  "ui-addon-sales-email": "static-1.4899",
  "hubspotter-http-shared-msw-handlers": "static-1.9176",
  "magpie-lib": "static-1.5259",
  "magpie-types": "static-1.4719",
  "simple-logging-lib": "static-1.2735",
  "content-assistance-lib": "static-1.7281",
  "dashboard-lib": "static-1.80159",
  "ExportDialog": "static-6.10071",
  "hubspot-prosemirror": "static-1.17295",
  "hubspot-prosemirror-plugins": "static-1.17287",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8372",
  "campaign-roi-lib": "static-1.7924",
  "feedback-loader": "static-1.28651",
  "commerce-analytics-service-client": "static-1.3367",
  "onboarding-scopes": "static-1.6128",
  "apollo-link-hub-http": "static-2.4333",
  "hubspot-apollo-cache": "static-1.24",
  "growth-monetization-service-types": "static-1.4220",
  "nav-client-types": "static-1.2017",
  "purchase-motions-api": "static-1.5313",
  "trials-service-types": "static-1.3621",
  "chatspot-client-types": "static-1.10322",
  "idb-keyval": "static-1.37",
  "reactive-lib": "static-1.411",
  "getting-started-shared-tasks-store": "static-1.16663",
  "integrations-error-boundary-lib": "static-1.12457",
  "integrations-tracking-lib": "static-1.5268",
  "native-integrations-shared-strings": "static-1.7472",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10059",
  "rxjs": "static-5.10",
  "calling-error-reporting": "static-1.30980",
  "shared-worker-versioning": "static-1.10702",
  "calling-usage-tracker": "static-1.6223",
  "calling-orchestration-shared-library": "static-1.34449",
  "customer-data-tracking": "static-1.6546",
  "products-iframe-lib": "static-1.7041",
  "products-ui-components-shared-msw-handlers": "static-1.9560",
  "location-customization-utils-lib": "static-1.8190",
  "apollo-dlb": "static-3.80",
  "immerable": "static-1.3841",
  "video-components-external": "static-1.10209",
  "video-data-lib": "static-1.33867",
  "directed-graph": "static-1.620",
  "event-emitter": "static-1.610",
  "breeze-intelligence-kit": "static-1.5148",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9261",
  "fsm": "static-1.3416",
  "policy-lib": "static-1.6487",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9324",
  "navigation-messaging": "static-1.6257",
  "FileManagerLib": "static-1.38188",
  "NamespacedHubStyle": "static-2.8795",
  "FileManagerCore": "static-1.38047",
  "codemirror": "static-5.88",
  "layout-dnd-components": "static-1.11830",
  "layout-dnd-utils": "static-1.10805",
  "react-codemirror": "static-1.10288",
  "ui-addon-emoji-picker": "static-1.9575",
  "ui-brand-identity-lib": "static-1.13380",
  "ui-addon-video-player": "static-1.8406",
  "ui-coaching-tips": "static-1.27625",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8266",
  "payment-link-components": "static-1.22623",
  "EmailSignatureEditor": "static-1.23717",
  "eligibility-engine-service-types": "static-1.2902",
  "universal-page-editor-lib": "static-1.2682",
  "calling-orchestration-schema": "static-1.34674",
  "sales-views-client-types": "static-1.3978",
  "crm-record-cards-service-types": "static-1.3345",
  "content-media-composition-data-lib": "static-1.10956",
  "content-media-compositions": "static-2.14963",
  "media-bridge-lib": "static-1.18379",
  "trellis-story-utils": "static-1.4208",
  "storybook-react": "static-1.26",
  "audio-components": "static-1.5446",
  "FileManagerImages": "static-1.35699",
  "video-components": "static-1.12212",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4215",
  "video-embed": "static-1.34701",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67321",
  "layout-data-lib": "static-1.9130",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6271",
  "commerce-tours-lib": "static-1.5540",
  "growth-onboarding-reliability": "static-1.4773",
  "sales-checkout-service-client": "static-1.3379",
  "draft-convert": "static-2.31",
  "draft-extend": "static-2.46",
  "draft-js": "static-5.37",
  "draft-plugins": "static-2.21102",
  "sales-email-signature-service-client": "static-1.3524",
  "hls.js": "static-1.32",
  "social-insights-client-types": "static-1.21062",
  "outpost": "static-1.3899",
  "advanced-menus-core": "static-1.14629",
  "advanced-menus-lib": "static-1.11624",
  "ui-memberships-settings-lib": "static-1.33113",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14628",
  "simple-menus-lib": "static-1.16145"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.33686",
  "client-types": "/client-types/static-1.441",
  "documents-lib": "/documents-lib/static-1.33691",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1801",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4702",
  "highcharts": "/highcharts/static-8.97",
  "hs-promise-utils": "/hs-promise-utils/static-1.5276",
  "hs-test-utils": "/hs-test-utils/static-1.7665",
  "hub-http": "/hub-http/static-1.5872",
  "hubspot-dlb": "/hubspot-dlb/static-2.1773",
  "HubStyleTokens": "/HubStyleTokens/static-2.11104",
  "I18n": "/I18n/static-7.1537",
  "jasmine-immutable": "/jasmine-immutable/static-1.2699",
  "jasmine-runner": "/jasmine-runner/static-1.6136",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6558",
  "react": "/react/static-7.175",
  "react-dlb": "/react-dlb/static-1.69",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.65",
  "react-rhumb": "/react-rhumb/static-1-feature-id-1324-better-marker-tracking.14",
  "reporting-data": "/reporting-data/static-1.65995",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.7929",
  "reporting-visualizations": "/reporting-visualizations/static-1.58072",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4429",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.4757",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2146",
  "classnames": "/classnames/static-2.10",
  "crm_schema": "/crm_schema/static-3.90904",
  "cssUtils": "/cssUtils/static-1.693",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38471",
  "customer-data-objects": "/customer-data-objects/static-1.7296",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7751",
  "data-fetching-client": "/data-fetching-client/static-1.9359",
  "enviro": "/enviro/static-4.371",
  "FireAlarmUi": "/FireAlarmUi/static-1.4220",
  "flux-actions": "/flux-actions/static-1.294",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.84944",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4416",
  "foundations-components": "/foundations-components/static-1.7269",
  "history": "/history/static-4.47",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3825",
  "HubStyle": "/HubStyle/static-2.11412",
  "icons": "/icons/static-2.610",
  "immutable": "/immutable/static-2.19",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.6825",
  "metrics-js": "/metrics-js/static-1.9296",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.334",
  "property-description-translator": "/property-description-translator/static-1.3544",
  "property-translator": "/property-translator/static-1.5098",
  "quartz-config": "/quartz-config/static-1.336",
  "quartz-core": "/quartz-core/static-1.5777",
  "quick-fetch": "/quick-fetch/static-1.3622",
  "raven": "/raven/static-3.5564",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5070",
  "react-virtualized": "/react-virtualized/static-2.92",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.7844",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7776",
  "report-customization-components": "/report-customization-components/static-1.12190",
  "reporting-enablement": "/reporting-enablement/static-1.21690",
  "reporting-reports": "/reporting-reports/static-1.65674",
  "reporting-snowflake": "/reporting-snowflake/static-1.54614",
  "reporting-ui-components": "/reporting-ui-components/static-2.63268",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4289",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8619",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8725",
  "sanitize": "/sanitize/static-1.4160",
  "sanitize-text": "/sanitize-text/static-1.7826",
  "self-service-api": "/self-service-api/static-1.9910",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.179",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1453",
  "signup-constants": "/signup-constants/static-1.18168",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20178",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7711",
  "styled-components": "/styled-components/static-2.83",
  "StyleGuideUI": "/StyleGuideUI/static-3.481",
  "superstore": "/superstore/static-1.4455",
  "transmute": "/transmute/static-2.77",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10681",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10810",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9230",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17394",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10538",
  "ui-images": "/ui-images/static-2.1055",
  "UIComponents": "/UIComponents/static-3.8051",
  "usage-tracker": "/usage-tracker/static-1.7020",
  "usage-tracker-container": "/usage-tracker-container/static-1.7010",
  "usage-tracker-core": "/usage-tracker-core/static-1.6870",
  "usage-tracker-public": "/usage-tracker-public/static-1.6831",
  "viral-links-lib": "/viral-links-lib/static-1.6702",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5234",
  "raven-hubspot": "/raven-hubspot/static-1.5871",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3120",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2835",
  "quartz-webpack": "/quartz-webpack/static-1.2782",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8051",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.53",
  "foundations-assets": "/foundations-assets/static-1.4515",
  "foundations-theming": "/foundations-theming/static-1.4085",
  "react-transition-group": "/react-transition-group/static-1.7",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4706",
  "foundations-theming-base": "/foundations-theming-base/static-1.3070",
  "HeadJS": "/HeadJS/static-2.686",
  "framer-motion": "/framer-motion/static-1.64",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2776",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.145",
  "i18n-data": "/i18n-data/static-1.214",
  "moment-timezone": "/moment-timezone/static-5.76",
  "jasmine": "/jasmine/static-4.4015",
  "csstype": "/csstype/static-1.50",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7608",
  "graphql": "/graphql/static-1.75",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3352",
  "persist-promise": "/persist-promise/static-1.3370",
  "reporting-client-types": "/reporting-client-types/static-1.2350",
  "hs-story-utils": "/hs-story-utils/static-1.9113",
  "react-flip-move": "/react-flip-move/static-1.63",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9178",
  "hubspotter-http": "/hubspotter-http/static-1.4371",
  "sassPrefix": "/sassPrefix/static-1.149",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6936",
  "crm-message-bus": "/crm-message-bus/static-1.42046",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.20905",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12686",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12817",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9508",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3740",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6453",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6548",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3571",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.649",
  "onboarding-tours": "/onboarding-tours/static-1.16107",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.12667",
  "ui-addon-teams": "/ui-addon-teams/static-1.21067",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.67246",
  "customer-data-properties": "/customer-data-properties/static-1.50440",
  "forms-ai-lib": "/forms-ai-lib/static-1.3804",
  "forms-utils-lib": "/forms-utils-lib/static-1.11949",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4752",
  "react-dnd-compat": "/react-dnd-compat/static-1.4309",
  "react-tinymce": "/react-tinymce/static-1.54309",
  "tinymce-config": "/tinymce-config/static-2.53435",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10031",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3538",
  "floating-ui": "/floating-ui/static-1.49",
  "react-aria": "/react-aria/static-1.59",
  "tanstack-table": "/tanstack-table/static-1.48",
  "trellis-assets": "/trellis-assets/static-1.951",
  "ui-fonts": "/ui-fonts/static-1.366",
  "dispatcher": "/dispatcher/static-1.129",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.766",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.459",
  "quartz-auth": "/quartz-auth/static-1.233",
  "quartz-head": "/quartz-head/static-1.223",
  "quartz-i18n": "/quartz-i18n/static-1.233",
  "quartz-test": "/quartz-test/static-1.233",
  "batch-promise": "/batch-promise/static-1.1213",
  "external-options-client-types": "/external-options-client-types/static-1.3876",
  "react-colorpicker": "/react-colorpicker/static-2.9898",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.836",
  "copilot-toolkit": "/copilot-toolkit/static-1.10237",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12061",
  "html-to-image": "/html-to-image/static-1.47",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40392",
  "reporting-plugins": "/reporting-plugins/static-1.9835",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.3939",
  "ui-addon-opt": "/ui-addon-opt/static-4.8074",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9825",
  "zustand": "/zustand/static-1.51",
  "growth-payments-core": "/growth-payments-core/static-1.24400",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4565",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3887",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8701",
  "merchandise-lib": "/merchandise-lib/static-1.253",
  "emoji-regex": "/emoji-regex/static-1.7",
  "feature-store-service-types": "/feature-store-service-types/static-1.4213",
  "purchase-motions-components": "/purchase-motions-components/static-1.5310",
  "salesImages": "/salesImages/static-1.518",
  "ts-schema": "/ts-schema/static-1.3797",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4204",
  "timezone-utils": "/timezone-utils/static-2.4929",
  "bender-build-tools": "/bender-build-tools/static-1.2798",
  "chatspot-core": "/chatspot-core/static-1.19867",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2568",
  "stylex": "/stylex/static-1.25",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3515",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3858",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3415",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17545",
  "growth-data-modal": "/growth-data-modal/static-1.5015",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2736",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1177",
  "navigation-components": "/navigation-components/static-1.16930",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4321",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.173",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7206",
  "ui-universal-auth": "/ui-universal-auth/static-1.8539",
  "user-context": "/user-context/static-1.4774",
  "cms-field-types": "/cms-field-types/static-1.4488",
  "content-icons-ui": "/content-icons-ui/static-1.2110",
  "integrations-lib": "/integrations-lib/static-1.15042",
  "calling-global-api": "/calling-global-api/static-1.63254",
  "calling-internal-common": "/calling-internal-common/static-1.30974",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64636",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.56930",
  "commerce-products-lib": "/commerce-products-lib/static-1.8498",
  "crm-links": "/crm-links/static-1.5933",
  "file-manager-components": "/file-manager-components/static-1.22548",
  "google-libphonenumber": "/google-libphonenumber/static-1.31",
  "hs-entities": "/hs-entities/static-1.334",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.3943",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.318",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.47606",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3679",
  "property-value-citations": "/property-value-citations/static-1.1054",
  "pulse": "/pulse/static-1.168",
  "smart-property-lib": "/smart-property-lib/static-1.5464",
  "tiered-pricing": "/tiered-pricing/static-1.644",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8697",
  "final-form": "/final-form/static-1.63",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19263",
  "tinymce-themes": "/tinymce-themes/static-1.55405",
  "data-token-picker": "/data-token-picker/static-1.15860",
  "hub-http-contrib": "/hub-http-contrib/static-1.2733",
  "interframe": "/interframe/static-3.4474",
  "tinymce-data": "/tinymce-data/static-1.39520",
  "tinymce-plugins": "/tinymce-plugins/static-1.56549",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4899",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9176",
  "magpie-lib": "/magpie-lib/static-1.5259",
  "magpie-types": "/magpie-types/static-1.4719",
  "simple-logging-lib": "/simple-logging-lib/static-1.2735",
  "content-assistance-lib": "/content-assistance-lib/static-1.7281",
  "dashboard-lib": "/dashboard-lib/static-1.80159",
  "ExportDialog": "/ExportDialog/static-6.10071",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17295",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17287",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8372",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.7924",
  "feedback-loader": "/feedback-loader/static-1.28651",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3367",
  "onboarding-scopes": "/onboarding-scopes/static-1.6128",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4333",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.24",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4220",
  "nav-client-types": "/nav-client-types/static-1.2017",
  "purchase-motions-api": "/purchase-motions-api/static-1.5313",
  "trials-service-types": "/trials-service-types/static-1.3621",
  "chatspot-client-types": "/chatspot-client-types/static-1.10322",
  "idb-keyval": "/idb-keyval/static-1.37",
  "reactive-lib": "/reactive-lib/static-1.411",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16663",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12457",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5268",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7472",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10059",
  "rxjs": "/rxjs/static-5.10",
  "calling-error-reporting": "/calling-error-reporting/static-1.30980",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10702",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6223",
  "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.34449",
  "customer-data-tracking": "/customer-data-tracking/static-1.6546",
  "products-iframe-lib": "/products-iframe-lib/static-1.7041",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9560",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8190",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "immerable": "/immerable/static-1.3841",
  "video-components-external": "/video-components-external/static-1.10209",
  "video-data-lib": "/video-data-lib/static-1.33867",
  "directed-graph": "/directed-graph/static-1.620",
  "event-emitter": "/event-emitter/static-1.610",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5148",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9261",
  "fsm": "/fsm/static-1.3416",
  "policy-lib": "/policy-lib/static-1.6487",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9324",
  "navigation-messaging": "/navigation-messaging/static-1.6257",
  "FileManagerLib": "/FileManagerLib/static-1.38188",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8795",
  "FileManagerCore": "/FileManagerCore/static-1.38047",
  "codemirror": "/codemirror/static-5.88",
  "layout-dnd-components": "/layout-dnd-components/static-1.11830",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.10805",
  "react-codemirror": "/react-codemirror/static-1.10288",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9575",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13380",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8406",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27625",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8266",
  "payment-link-components": "/payment-link-components/static-1.22623",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23717",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2902",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2682",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34674",
  "sales-views-client-types": "/sales-views-client-types/static-1.3978",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3345",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.10956",
  "content-media-compositions": "/content-media-compositions/static-2.14963",
  "media-bridge-lib": "/media-bridge-lib/static-1.18379",
  "trellis-story-utils": "/trellis-story-utils/static-1.4208",
  "storybook-react": "/storybook-react/static-1.26",
  "audio-components": "/audio-components/static-1.5446",
  "FileManagerImages": "/FileManagerImages/static-1.35699",
  "video-components": "/video-components/static-1.12212",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4215",
  "video-embed": "/video-embed/static-1.34701",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67321",
  "layout-data-lib": "/layout-data-lib/static-1.9130",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6271",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5540",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4773",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3379",
  "draft-convert": "/draft-convert/static-2.31",
  "draft-extend": "/draft-extend/static-2.46",
  "draft-js": "/draft-js/static-5.37",
  "draft-plugins": "/draft-plugins/static-2.21102",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3524",
  "hls.js": "/hls.js/static-1.32",
  "social-insights-client-types": "/social-insights-client-types/static-1.21062",
  "outpost": "/outpost/static-1.3899",
  "advanced-menus-core": "/advanced-menus-core/static-1.14629",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11624",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33113",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14628",
  "simple-menus-lib": "/simple-menus-lib/static-1.16145"
}
};
